import { useMediaQuery, useTheme } from '@mui/system';
import { useEffect, useState } from 'react';

export const useDeviceType = () => {
  const [isMobile, setIsMobile] = useState(false);

  const theme = useTheme();
  const isMediaMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    const isUserAgentMobile = /iphone|android|mobile/i.test(navigator.userAgent.toLowerCase());

    const checkMobile = () => {
      const isMobileChecked = navigator.maxTouchPoints > 0 && isUserAgentMobile;

      setIsMobile(isMobileChecked);
    };

    checkMobile();

    window.addEventListener('resize', checkMobile);

    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, [isMediaMobile]);

  return { isMobile };
};
